/* 
https://www.iconfinder.com/icons/1243689/call_phone_icon
Creative Commons (Attribution 3.0 Unported);
https://www.iconfinder.com/Makoto_msk */

export const storeProducts = [
  {
    id: 1,
    title: "PSG (H) ",
    name: "Paris St-Germain Home Kit",
    img: "kits/pasg.jpg",
    price: 60,
    brand: "Nike",
    info:
      "Jersey fits true to size ,Material is 100% Polyester,Nike Breathe fabrics move sweat from your skin and feature highly breathable construction to help you stay dry and comfortable,Dri-FIT technology that  wicks away moisture,Woven Authentic Nike jock tag on left hem,Embroidered Nike ® logo on right chest,Sewn on embroidered team crest on left chest.and is Machine washable",
    inCart: false,
    count: 0,
    total: 0,
  },
  {
    id: 2,
    title: "LIVERPOOL (H) ",
    name: "Liverpool FC Home Kit",
    // img: "img/product-2.png",
    img: "kits/images (1).jpg",

    price: 80,
    brand: "New Balance",
    info:
      "Jersey fits true to size ,Material is 100% Polyester,Nike Breathe fabrics move sweat from your skin and feature highly breathable construction to help you stay dry and comfortable,Dri-FIT technology that  wicks away moisture,Woven Authentic Nike jock tag on left hem,Embroidered Nike ® logo on right chest,Sewn on embroidered team crest on left chest.and is Machine washable",
    inCart: false,
    count: 0,
    total: 0,
  },
  {
    id: 3,
    title: "BARCELONA (H)",
    name: "FC Barcelona Home Kit",
    img: "kits/images (3).jpg",
    price: 60,
    brand: "Nike",
    info:
      "The great return of the stripes on the classic Blaugrana jersey, but this year they are of exceptional importance for footballers, as well as fans.The motif of vertical stripes along with the yellow collar is a reference to the jersey from the 2010/11 season, when the team from Barcelona won the Spanish championship and the Champions League.On the collar of the jersey there is an insert in the colors of Senyery i.e. the famous Catalan flag. The club from the capital of the region has repeatedly emphasized its origin and also this year decided to put such an emphasis on its most important kit.The patch with the serial code at the bottom and the original labels are proof of authenticity - we only import jerseys from the official source",
    inCart: false,
    count: 0,
    total: 0,
  },
  {
    id: 4,
    title: "MAN CITY (H)",
    name: "Manchester City Home Kit",
    img: "kits/images (2).jpg",
    price: 90,
    brand: "Nike",
    info:
      "Jersey fits true to size ,Material is 100% Polyester,Nike Breathe fabrics move sweat from your skin and feature highly breathable construction to help you stay dry and comfortable,Dri-FIT technology that  wicks away moisture,Woven Authentic Nike jock tag on left hem,Embroidered Nike ® logo on right chest,Sewn on embroidered team crest on left chest.and is Machine washable",
    inCart: false,
    count: 0,
    total: 0,
  },
  {
    id: 5,
    title: "ATLETICO (A)",
    name: " Atletico Madrid Away Kit",
    img: "kits/images (5).jpg",
    price: 70,
    brand: "Nike",
    info:
      "Jersey fits true to size ,Material is 100% Polyester,Nike Breathe fabrics move sweat from your skin and feature highly breathable construction to help you stay dry and comfortable,Dri-FIT technology that  wicks away moisture,Woven Authentic Nike jock tag on left hem,Embroidered Nike ® logo on right chest,Sewn on embroidered team crest on left chest.and is Machine washable",
    inCart: false,
    count: 0,
    total: 0,
  },
  {
    id: 6,
    title: "MAN UTD (H)",
    name: " Manchester United Home Kit",
    img: "kits/images (4).jpg",
    price: 110,
    brand: "Adidas",
    info:
      "Jersey fits true to size ,Material is 100% Polyester,Nike Breathe fabrics move sweat from your skin and feature highly breathable construction to help you stay dry and comfortable,Dri-FIT technology that  wicks away moisture,Woven Authentic Nike jock tag on left hem,Embroidered Nike ® logo on right chest,Sewn on embroidered team crest on left chest.and is Machine washable",
    inCart: false,
    count: 0,
    total: 0,
  },

  {
    id: 7,
    title: "BVB (H)",
    name: " Borussia Dortmund Home Kit",
    img: "kits/images (8).jpg",
    price: 60,
    brand: "Puma",
    info:
      "Jersey fits true to size ,Material is 100% Polyester,Nike Breathe fabrics move sweat from your skin and feature highly breathable construction to help you stay dry and comfortable,Dri-FIT technology that  wicks away moisture,Woven Authentic Nike jock tag on left hem,Embroidered Nike ® logo on right chest,Sewn on embroidered team crest on left chest.and is Machine washable",
    inCart: false,
    count: 0,
    total: 0,
  },
  {
    id: 8,
    title: "CHELSEA (H)",
    name: "Chelsea FC Home Kit",
    img: "kits/images (6).jpg",
    price: 110,
    brand: "Nike",
    info:
      "Jersey fits true to size ,Material is 100% Polyester,Nike Breathe fabrics move sweat from your skin and feature highly breathable construction to help you stay dry and comfortable,Dri-FIT technology that  wicks away moisture,Woven Authentic Nike jock tag on left hem,Embroidered Nike ® logo on right chest,Sewn on embroidered team crest on left chest.and is Machine washable",
    inCart: false,
    count: 0,
    total: 0,
  },
  {
    id: 9,
    title: "REAL MADRID (H)",
    name: "Real Madrid Home Kit",
    img: "kits/images.jpg",
    price: 90,
    brand: "Adidas",
    info:
      "Jersey fits true to size ,Material is 100% Polyester,Nike Breathe fabrics move sweat from your skin and feature highly breathable construction to help you stay dry and comfortable,Dri-FIT technology that  wicks away moisture,Woven Authentic Nike jock tag on left hem,Embroidered Nike ® logo on right chest,Sewn on embroidered team crest on left chest.and is Machine washable",
    inCart: false,
    count: 0,
    total: 0,
  },

  {
    id: 10,
    title: "BAYERN (A)",
    name: "FC Bayern Munich Away Kit",
    img: "kits/images (7).jpg",
    price: 60,
    brand: "Adidas",
    info:
      "Jersey fits true to size ,Material is 100% Polyester,Nike Breathe fabrics move sweat from your skin and feature highly breathable construction to help you stay dry and comfortable,Dri-FIT technology that  wicks away moisture,Woven Authentic Nike jock tag on left hem,Embroidered Nike ® logo on right chest,Sewn on embroidered team crest on left chest.and is Machine washable",
    inCart: false,
    count: 0,
    total: 0,
  },

  {
    id: 11,
    title: "CR7",
    name: "CHRISTIANO RONALDO ICONIC JERSEY",
    img: "kits/ronaldo.jpg",
    price: 150,
    brand: "Adidas",
    info:
      "Jersey fits true to size ,Material is 100% Polyester,Nike Breathe fabrics move sweat from your skin and feature highly breathable construction to help you stay dry and comfortable,Dri-FIT technology that  wicks away moisture,Woven Authentic Nike jock tag on left hem,Embroidered Nike ® logo on right chest,Sewn on embroidered team crest on left chest.and is Machine washable",
    inCart: false,
    count: 0,
    total: 0,
  },
  {
    id: 12,
    title: "SPURS (H)",
    name: "Tottenham Hotspurs Home Kit",
    img: "kits/images (9).jpg",
    price: 77,
    brand: "Nike",
    info:
      "Jersey fits true to size ,Material is 100% Polyester,Nike Breathe fabrics move sweat from your skin and feature highly breathable construction to help you stay dry and comfortable,Dri-FIT technology that  wicks away moisture,Woven Authentic Nike jock tag on left hem,Embroidered Nike ® logo on right chest,Sewn on embroidered team crest on left chest.and is Machine washable",
    inCart: false,
    count: 0,
    total: 0,
  },
];
//placeholder
export const detailProduct = {
  id: 1,
  title: "PSG (H) ",
  name: "Paris St-Germain Home Kit",
  img: "kits/pasg.jpg",
  price: 60,
  brand: "Nike",
  info:
    "Jersey fits true to size ,Material is 100% Polyester,Nike Breathe fabrics move sweat from your skin and feature highly breathable construction to help you stay dry and comfortable,Dri-FIT technology that  wicks away moisture,Woven Authentic Nike jock tag on left hem,Embroidered Nike ® logo on right chest,Sewn on embroidered team crest on left chest.and is Machine washable",
  inCart: false,
  count: 0,
  total: 0,
};
